import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BarChart3, BookOpen, Home, RefreshCw, Trophy, User, Users, Zap } from 'lucide-react';
import { styles } from './DesktopSideNav.styles';

/**
 * Desktop side navigation with Minecraft-themed design.
 */
export const DesktopSideNav: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation('common');

  const navItems = [
    { label: t('navigation.dashboard'), path: '/dashboard', Icon: Home },
    { label: t('navigation.topics'), path: '/topics', Icon: BookOpen },
    { label: t('navigation.dailyChallenge'), path: '/daily-challenge', Icon: Zap },
    { label: t('navigation.review'), path: '/review', Icon: RefreshCw },
    { label: t('navigation.badges'), path: '/badges', Icon: Trophy },
    { label: t('navigation.friends'), path: '/friends', Icon: Users },
    { label: t('navigation.leaderboard'), path: '/leaderboard', Icon: BarChart3 },
    { label: t('navigation.profile'), path: '/profile', Icon: User },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav style={styles.sideNav}>
      <div style={styles.navContainer} className="minecraft-panel">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              aria-label={item.label}
              title={item.label}
              style={{
                ...styles.navItem,
                ...(active ? styles.navItemActive : styles.navItemInactive),
              }}
            >
              <item.Icon size={24} aria-hidden="true" />
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
